export default __webpack_public_path__ + "static/media/uo-logo.1aeafa18.png";